import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { NotificationDialog } from '../../CommonFunctions/DialogComponents';
import ShortUniqueId from 'short-unique-id';
import { AlertColor, Box } from '@mui/material';
import { useDrop } from 'react-dnd';
import { updateFieldOfDimensionOverride } from '../../../redux/Calculations/CalculationsActions';
interface IDimensionOverrideDropZoneProps {
  children: React.ReactNode;
  propKey: string;
}
function DimensionOverrideDropZone({ children, propKey }: IDimensionOverrideDropZoneProps) {
  const uid = new ShortUniqueId({ length: 4 });
  const [showBorder, setShowBorder] = useState(false);
  const dispatch = useDispatch();

  const [alert, setAlert] = useState<{
    severity: AlertColor;
    message: string;
  } | null>(null);
  const [{ isOver }, drop] = useDrop({
    accept: ['card', 'calculation'],
    hover: (item: any, monitor) => {
      if (monitor.isOver({ shallow: true }) && !showBorder) {
        setShowBorder(true);
      }
    },
    collect: (monitor) => ({
      isOver: monitor.isOver({ shallow: true }),
    }),
    drop: (item: any, monitor) => {
      const fieldId = uid();
      if (item.fieldData.isAggregated) {
        setAlert({
          severity: 'warning',
          message: 'Aggregated fields cannot be added as override filters.',
        });
        setShowBorder(false);
        return;
      }
      const { dataType, displayname, fieldname, tableId } = item.fieldData;
      const fieldInfo = {
        uid: fieldId as string,
        dataType: dataType as string,
        displayName: displayname as string,
        fieldName: fieldname as string,
        tableId: tableId as string,
        timeGrain: 'year',
        customization: false,
      };
      dispatch(updateFieldOfDimensionOverride(propKey, fieldInfo, 'add'));
      setShowBorder(false);
    },
  });
  useEffect(() => {
    if (!isOver) {
      setShowBorder(false);
    }
  }, [isOver]);
  return (
    <>
      {alert && (
        <NotificationDialog
          severity={alert.severity}
          openAlert={!!alert}
          onCloseAlert={() => setAlert(null)}
          testMessage={alert.message}
        />
      )}
      <Box
        ref={drop}
        className={`dropzone ${showBorder ? 'dropzone-highlighted' : ''}`}
        sx={{
          paddingInline: '0.2rem',
          textAlign: 'left',
          paddingBottom: '2rem',
          paddingTop: '5px',
          border: '1px solid transparent',
          height: 'auto',
          marginBottom: '0.5rem',
          flexGrow: 1,
        }}
      >
        {children}
      </Box>
    </>
  );
}

export default DimensionOverrideDropZone;
